import styled from 'styled-components';

export const TooltipWrapper = styled.div`
  height: 20px;
`;
